










































import { SketchRelatedData } from '@tt4b/ttam-enums';
import { useAutoSaveSketchRelatedData } from '@tt4b/ttam-hooks';
import { trackEvent } from '@tt4b/ttam-utils';
import { defineComponent, PropType, ref, toRefs } from '@vue/composition-api';

const name = 'ttam-auto-save-exit-reach-limit-dialog';
export default defineComponent({
  name,
  props: {
    visible: { type: Boolean, default: false },
    campaignSketchRelatedData: {
      type: Object as PropType<SketchRelatedData>,
      default: () => ({}),
    },
    adgroupSketchRelatedData: {
      type: Object as PropType<SketchRelatedData>,
      default: () => ({}),
    },
    creativeSketchRelatedData: {
      type: Object as PropType<SketchRelatedData>,
      default: () => ({}),
    },
  },

  setup(props, { emit }) {
    const { campaignSketchRelatedData, adgroupSketchRelatedData, creativeSketchRelatedData } = toRefs(props);
    const isNotShowAnymore = ref(false);

    const {
      isCampaignSketchReachLimitError,
      isAdgroupSketchReachLimitError,
      isCreativeSketchReachLimitError,
      isSketchSaving,
    } = useAutoSaveSketchRelatedData({
      campaignSketchRelatedData,
      adgroupSketchRelatedData,
      creativeSketchRelatedData,
    });

    const handleClose = () => {
      emit('close');
    };

    const handleRetry = () => {
      emit('retry');
      emit('close');
    };

    const handleExit = () => {
      trackEvent('ttam_creation_draft_exit_on_error_upper_limit_exit');
      emit('exit', isNotShowAnymore.value);
      emit('close');
    };

    const handleManageDraft = () => {
      trackEvent('ttam_creation_draft_exit_on_error_upper_limit_manager_draft');
      emit('manage-draft');
    };

    return {
      name,
      isNotShowAnymore,
      isSketchSaving,
      isCampaignSketchReachLimitError,
      isAdgroupSketchReachLimitError,
      isCreativeSketchReachLimitError,
      handleExit,
      handleClose,
      handleRetry,
      handleManageDraft,
    };
  },
});
